import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandMore } from '@material-ui/icons';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import type { LeverandorGodkjenningProsessResponse } from '@klp/leverandor/types';
import { LeverandorActionsList } from './LeverandorActionList';
import { useFormAuth } from '@klp/formgenerator/hooks';

const styles = () => ({
    accordion: {
        padding: 0,
    },
    list: { width: '100%' },
});

type ProsjektActionsProps = {
    leverandor: LeverandorGodkjenningProsessResponse;
    isEDAdmin: boolean | undefined;
    navigateOnDelete?: boolean;
    defaultRolle?: string;
};

export const LeverandorActions: React.FC<ProsjektActionsProps> = ({
    leverandor,
    leverandor: { currentAktivitet },
    isEDAdmin = false,
    navigateOnDelete = false,
    defaultRolle,
}) => {
    const classes = useKlpStyles({}, styles);
    const { t } = useTranslation();

    const { isActivityEditable } = useFormAuth();
    const [accordionExpanded, setAccordionExpanded] = React.useState(() =>
        currentAktivitet ? !isActivityEditable(currentAktivitet) : true,
    );

    const handleAccordionChange = () => {
        setAccordionExpanded(!accordionExpanded);
    };

    return (
        <Accordion
            className={classes.accordion}
            data-testid="LeverandorActionsAccordion"
            expanded={accordionExpanded}
            onChange={handleAccordionChange}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                {t('leverandor.table.actionMenuItems.currentHeader')}
            </AccordionSummary>
            <AccordionDetails>
                <LeverandorActionsList
                    leverandor={leverandor}
                    isEDAdmin={isEDAdmin}
                    navigateOnDelete={navigateOnDelete}
                    selectedElement="detaljer"
                    defaultRolle={defaultRolle}
                />
            </AccordionDetails>
        </Accordion>
    );
};
